import React, { useRef } from 'react'
import { Dialog } from '@headlessui/react'
import { COLORS } from '../../config';
import SuccessCheckIcon from '../../components/Icons/outline/SuccessCheckIcon';
import ErrorXIcon from '../../components/Icons/outline/ErrorXIcon';
import MoonLoader from 'react-spinners/MoonLoader';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import useTreatments from '../../store/treatments/treatmentsContext';

export default function CheckoutModal({ 
  showCheckout,
  setShowCheckout,
  initiatePayment,
  treatmentId,
  setSelectedPaymentItems,
  setTotalPaymentAmount
}) {
  
  const {
    getTreatmentTransactions
  } = useTreatments();

  let completeButtonRef = useRef(null)

  const [isLoading, setIsLoading] = React.useState(true);
  const [paymentSuccess, setPaymentSuccess] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);

  const handleClick = () => {
    setShowCheckout(false)
    setIsLoading(true);
  }

  React.useEffect(() => {
    if (showCheckout) {
      initiatePayment().then(res => {
        if (res?.success) {
          setPaymentSuccess(true)
          getTreatmentTransactions(treatmentId)
          setSelectedPaymentItems([])       
          setTotalPaymentAmount(0)
        } else {
          setPaymentSuccess(false)
          setErrorMessage(res.data?.message || 'There was an issue with your payment')
        }
        setIsLoading(false);
      }).catch(err => {
        setPaymentSuccess(false)
        setErrorMessage(err.response?.data?.message || 'There was an issue with your payment')
        setIsLoading(false);
      })

    }
    if (!showCheckout) {
      setIsLoading(true);
    }
  }, [showCheckout])

  return (
    /* Use `initialFocus` to force initial focus to a specific ref. */
    <Dialog
      className="fixed z-50 inset-0 overflow-y-auto"
      initialFocus={completeButtonRef}
      open={showCheckout}
      onClose={() => setShowCheckout(true)}
    >
      <div ref={completeButtonRef} className="flex items-center justify-center min-h-screen">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

        <div className={`inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-visible shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6`}>
          {isLoading ?
            <div className='flex justify-around min-h-170 pt-8'>
                <MoonLoader color={COLORS.colorPrimary}/>
            </div> 
            :  
            <div >
              {paymentSuccess && 
                <div className='flex flex-col items-center'>
                  <SuccessCheckIcon size='h-16 w-16' className='mb-8 flex-grow flex justify-around' stroke={COLORS.successGreen} />
                  <span className='text-xl mb-8'>Payment successful!</span>
                  <p className='mb-12'>Your payment information has been sent to your email</p>
                  <div className='flex w-full flex-row-reverse'>
                    <PrimaryButton text='Back' onClick={handleClick}/>
                  </div>
                </div>
              }
              {!paymentSuccess && 
              <div className='flex flex-col items-center'>
                <ErrorXIcon size='h-16 w-16' className='mb-8 flex-grow flex justify-around' stroke={COLORS.deleteRed} />
                <span className='text-xl mb-8'>Payment error!</span>
                <p className='mb-12'>{errorMessage}</p>
                <div className='flex w-full flex-row-reverse'>
                  <PrimaryButton text='Back' onClick={handleClick}/>
                </div>
              </div>
              }
          </div>
          }
        </div>
      </div>
    </Dialog>
  )
}